export default __webpack_public_path__ + "static/media/misc-drawerB-2048w.962e9097.webp";